<template>
  <v-row>
    <v-col>
      <v-card
        :class="{
          'py-6 px-12': $vuetify.breakpoint.mdAndUp,
          'pa-5': $vuetify.breakpoint.smAndDown
        }"
        no-body
      >
        <div class="title">
          {{ title }}
        </div>

        <v-divider></v-divider>
        <v-form v-model="formValidate" ref="form">
          <v-container :class="{ 'pa-0': $vuetify.breakpoint.xsOnly }">
            <v-row>
              <v-col>
                <span class="px-1">
                  วันที่เขียน
                  {{ otherData.leaveAssignDateText }}
                </span>
                <span class="px-1">
                  {{ otherData.leaveTypeName }}
                </span>
                <span class="info--text px-1">
                  {{ otherData.leaveTypeDesc }}
                </span>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.LeaveHead"
                  ref="LeaveHead"
                  label="เรียน"
                  hide-details="auto"
                  :rules="[rules.required]"
                  required
                  outlined
                  dense
                  maxlength="255"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.WifeName"
                  ref="WifeName"
                  label="ชื่อภริยาโดยชอบด้วยกฏหมาย"
                  hide-details="auto"
                  :rules="[rules.required]"
                  required
                  outlined
                  dense
                  maxlength="255"
                />
              </v-col>
            </v-row>

            <v-row class="mt-n2">
              <v-col
                cols="12"
                lg="6"
                :class="{ 'pb-1': $vuetify.breakpoint.mdAndDown }"
              >
                <v-menu
                  v-model="deliverMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      label="คลอดวันที่"
                      hide-details="auto"
                      append-icon="mdi-calendar"
                      :value="deliverDateText"
                      readonly
                      outlined
                      dense
                      @click:append="deliverMenu = true"
                    />
                  </template>
                  <v-date-picker
                    no-title
                    v-model="form.DeliverDate"
                    :locale="$lang === 'Tha' ? 'th' : 'en'"
                    @input="deliverMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="py-3">
              <v-col cols="12" class="py-0">
                <v-checkbox
                  v-model="otherData.leaveOneDay"
                  class="ma-0"
                  label="ลาวันเดียว"
                  hide-details="auto"
                  @change="onChangeDaySelection()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                lg="6"
                :class="{ 'pb-1': $vuetify.breakpoint.mdAndDown }"
              >
                <v-menu
                  v-model="beginMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      :value="beginDateText"
                      label="ลาตั้งแต่วันที่"
                      hide-details="auto"
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      @click:append="beginMenu = true"
                    />
                  </template>
                  <v-date-picker
                    no-title
                    v-model="form.LeaveBeginDate"
                    :locale="$lang === 'Tha' ? 'th' : 'en'"
                    @input="beginMenu = false"
                    @change="onChangeDaySelection()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                lg="6"
                :class="{ 'pt-1': $vuetify.breakpoint.mdAndDown }"
              >
                <v-radio-group
                  v-model="form.LeaveBeginDayStatusID"
                  class="ma-0"
                  row
                  hide-details="auto"
                  @change="onChangeDaySelection()"
                >
                  <v-radio label="เต็มวัน" value="ALL" />
                  <v-radio label="ครึ่งเช้า" value="AM" />
                  <v-radio label="ครึ่งบ่าย" value="PM" />
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row
              v-if="
                !(form.LeaveBeginDayStatusID === 'AM' || otherData.leaveOneDay)
              "
            >
              <v-col
                cols="12"
                lg="6"
                :class="{ 'pb-1': $vuetify.breakpoint.mdAndDown }"
              >
                <v-menu
                  v-model="finishMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      :value="finishDateText"
                      :disabled="
                        form.LeaveBeginDayStatusID === 'AM' ||
                          otherData.leaveOneDay
                      "
                      label="ลาถึงวันที่"
                      hide-details="auto"
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                    />
                  </template>
                  <v-date-picker
                    no-title
                    v-model="form.LeaveFinishDate"
                    :locale="$lang === 'Tha' ? 'th' : 'en'"
                    :min="
                      $dateFormat(form.LeaveBeginDate, {
                        addUnit: 'd',
                        addValue: 1
                      })
                    "
                    :disabled="
                      form.LeaveBeginDayStatusID === 'AM' ||
                        otherData.leaveOneDay
                    "
                    @input="finishMenu = false"
                    @change="onChangeDaySelection()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                lg="6"
                :class="{ 'pt-1': $vuetify.breakpoint.mdAndDown }"
              >
                <v-radio-group
                  v-model="form.LeaveFinishDayStatusID"
                  class="ma-0"
                  row
                  hide-details="auto"
                  :disabled="
                    form.LeaveBeginDayStatusID === 'AM' || otherData.leaveOneDay
                  "
                  @change="onChangeDaySelection()"
                >
                  <v-radio label="เต็มวัน" value="ALL" />
                  <v-radio label="ครึ่งเช้า" value="AM" />
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row class="py-3">
              <v-col cols="12" lg="auto" class="py-0">
                <v-checkbox
                  v-model="form.CheckSaturday"
                  class="ma-0"
                  label="นับวันเสาร์เป็นวันทำงาน"
                  hide-details="auto"
                  :disabled="isLeaveDeliver"
                  @change="onChangeDaySelection()"
                />
              </v-col>
              <v-col cols="12" lg="auto" class="py-0">
                <v-checkbox
                  v-model="form.CheckSunday"
                  class="ma-0"
                  label="นับวันอาทิตย์เป็นวันทำงาน"
                  hide-details="auto"
                  :disabled="isLeaveDeliver"
                  @change="onChangeDaySelection()"
                />
              </v-col>
              <v-col cols="12" lg="auto" class="py-0">
                <v-checkbox
                  v-model="form.CheckHoliday"
                  class="ma-0"
                  label="นับวันหยุดนักขัตฤกษ์เป็นวันทำงาน"
                  hide-details="auto"
                  :disabled="isLeaveDeliver"
                  @change="onChangeDaySelection()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="py-1">
                <span class="px-1">จำนวนวันลา</span>
                <span class="title px-1" v-text="form.LeaveAmountDay" />
                <span class="px-1" v-text="otherData.leaveDayName" />
                <span class="px-1">,</span>
                <span class="px-1">จำนวนวันลาทั้งหมด</span>
                <span class="title px-1" v-text="form.LeaveAmountDayAll" />
                <span class="px-1">วัน</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="mt-n2">
                <span
                  class="px-1 error--text"
                  v-text="otherData.warningMessage"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.Address"
                  ref="Address"
                  label="สามารถติดต่อได้ที่"
                  hide-details="auto"
                  :rules="[rules.required]"
                  required
                  outlined
                  dense
                  maxlength="255"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col />
            </v-row>

            <v-divider />

            <v-row>
              <v-col />
            </v-row>

            <!-- <leave-search-employee
              ref="leaveApprover"
              :selected-employee="form.EmployeeApproveID"
              :selected-employee-title="approverTitle"
              :selected-employee-name="otherData.employeeApprove[$lang]"
              :list="employeeApproveList"
              @search="onSearchEmpApprove"
              @select="onSelectApprover"
            /> -->
            <v-row>
              <v-col cols="12">
                <v-row class="ml-1">
                  <div>
                    <span
                      v-if="!otherData.employeeApprove[$lang]"
                      class="title error--text"
                      ref="leaveApprover"
                    >
                      *
                    </span>
                    <b>{{ approverTitle + ' : ' }}</b>
                    <span
                      v-if="!otherData.employeeApprove[$lang]"
                      class="title error--text"
                    >
                      กรุณาเลือกผู้ส่งต่อ
                    </span>
                    <span
                      v-else
                      class="title success--text"
                      v-text="otherData.employeeApprove[$lang] || ''"
                    />
                  </div>
                  <div v-if="!otherData.employeeApprove[$lang]">
                    <v-btn
                      color="primary"
                      outlined
                      @click="openDialog()"
                      class="white--text ml-2"
                    >
                      <v-icon>mdi-plus</v-icon>
                      ค้นหารายชื่อ</v-btn
                    >
                    <div>
                      <span v-if="leaveApproverStatus" class=" error--text">
                        * กรุณาค้นหารายชื่อเพื่อส่งต่อ
                      </span>
                    </div>
                  </div>
                  <div v-else class="ml-2">
                    <v-btn
                      color="orange"
                      outlined
                      @click="openDialog()"
                      class="white--text"
                    >
                      <v-icon>mdi-pencil</v-icon>
                      เปลี่ยน</v-btn
                    >
                  </div>
                </v-row>
              </v-col>
            </v-row>
            <v-row class=" mb-n5" align="center">
              <v-col cols="12">
                <v-btn
                  :color="isEditMode ? 'warning darken-1' : 'primary darken-2'"
                  depressed
                  large
                  @click="onSubmitForm()"
                  class="float-right"
                >
                  {{ isEditMode ? 'บันทึกการแก้ไข' : 'บันทึกข้อมูล' }}
                </v-btn>

                <v-btn
                  class="float-right mr-1"
                  outlined
                  large
                  color="grey"
                  :to="`/leave/pending/${$guid}`"
                  depressed
                >
                  ยกเลิก
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-dialog v-model="conDialogOnSubmitForm" max-width="500px">
        <v-card class="py-2">
          <v-card-title class="headline Black--text"
            >ยืนยันการบันทึกการลา</v-card-title
          >

          <v-card-text class="mb-4">
            <v-divider class="mb-2"></v-divider>
            <span class="text-body-1">ส่งรายการลาไปยัง </span>
            <span class="font-weight-bold">
              {{ otherData.employeeApprove[$lang] }}</span
            >
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n8">
              <v-btn
                class="white--text mr-2"
                color="error"
                outlined
                @click="conDialogOnSubmitForm = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                class="white--text mr-2"
                color="success"
                @click="conOnSubmitForm"
                >ยืนยัน
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12">
      <v-dialog v-model="loading1" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            กำลังบันทึก...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card> </v-dialog
    ></v-col>
    <v-col cols="12">
      <v-dialog v-model="searchDialog" max-width="800">
        <v-card class="px-5">
          <v-card-title class="headline Black--text">
            ค้นหารายชื่อ
          </v-card-title>
          <v-card-text class="mb-2">
            <v-divider class="mb-2"></v-divider>
            <leave-search-employee
              ref="leaveApprover"
              :selected-employee="form.EmployeeApproveID"
              :list="employeeApproveList"
              :isload="loading"
              @search="onSearchEmpApprove"
              @select="onSelectApprover"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n5 mb-3">
              <v-btn
                class="white--text mr-2"
                color="grey"
                outlined
                @click="searchDialog = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                class="white--text "
                color="primary"
                @click="btnSubmitSelect"
                :disabled="checkSearch"
                >บันทึก
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12">
      <app-message-dialog
        :value="usedLeaveLimitDialog"
        :message="usedLeaveLimitMessage"
        @confirm="onCloseUsedLeaveLimitDialog"
      />
    </v-col>
  </v-row>
</template>

<script>
import LeaveSearchEmployee from '@/components/leave/LeaveForm/LeaveSearchEmployeeDialogAuto'

export default {
  components: {
    LeaveSearchEmployee
  },

  props: {
    title: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: '22'
    }
  },

  data() {
    return {
      conDialogOnSubmitForm: false,
      loading1: false,
      loading: false,
      usedLeaveLimitDialog: false,
      usedLeaveLimitMessage: '',
      formValidate: null,
      deliverMenu: false,
      beginMenu: false,
      finishMenu: false,
      form: {},
      otherData: {
        docName: null,
        docFileName: null,
        leaveDayName: null,
        budgetYear: null,
        employeeApproveKeyword: '',
        employeeApprove: {
          ID: null,
          Tha: null,
          Eng: null
        },
        employeeName: {
          Tha: null,
          Eng: null
        },
        positionName: {
          Tha: null,
          Eng: null
        },
        orgNameAll: {
          Tha: null,
          Eng: null
        },
        leaveAssignDateText: null,
        leaveTypeName: null,
        leaveTypeDesc: null
      },
      leaveInfo: {},
      nextBudgetYearData: {
        has: false,
        budgetYear: null,
        leaveDayName: 'วันทำการ',
        statLeaveLastDay: 0,
        statLeaveNowDay: 0,
        statLeaveTotal: 0,
        warningMessage: ''
      },
      employeeApproveList: [],
      searchDialog: false,
      dataSelect: {},
      leaveApproverStatus: false,
      conDialogOnSubmitSkipUsework: false
    }
  },

  computed: {
    leaveOrderId() {
      return this.$route.params.leaveOrderId || '0'
    },

    deliverDateText() {
      return this.$dateFormatByLang(this.form.DeliverDate, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },

    beginDateText() {
      return this.$dateFormatByLang(this.form.LeaveBeginDate, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },

    finishDateText() {
      return this.$dateFormatByLang(this.form.LeaveFinishDate, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },

    rules() {
      return {
        required: v => !!v || 'กรุณากรอกข้อมูลช่องนี้'
      }
    },

    isEditMode() {
      return !!this.$route.params.leaveOrderId
    },

    approverTitle() {
      return 'ผู้บังคับบัญชา/ผู้ตรวจสอบการลา/ผู้อนุมัติการลา'
    },
    checkSearch() {
      return this.dataSelect.employeeID ? false : true
    }
  },

  watch: {
    'form.LeaveBeginDate'() {
      if (this.form.LeaveBeginDate >= this.form.LeaveFinishDate) {
        this.form.LeaveFinishDate = this.$dateFormat(this.form.LeaveBeginDate, {
          addValue: 1,
          addUnit: 'd'
        })
      }
    },

    otherData: {
      deep: true,
      handler() {
        this.$emit('updateOtherData', this.otherData)
      }
    },

    loading: {
      deep: true,
      handler() {
        this.$emit('updateLoading', this.loading)
      }
    }
  },

  async mounted() {
    this.leaveInfo = await this.apiGetLeaveInfo()
    this.intitialForm()
  },

  methods: {
    intitialForm() {
      this.form = {
        LeaveOrderID: this.leaveOrderId,
        EmployeeID: this.$guid,
        LeaveHead: this.leaveInfo.leaveHead || '',
        LeaveBeginDate:
          this.$dateFormat(this.leaveInfo.leaveBeginDate) ||
          this.$dateFormat(new Date().toISOString().substr(0, 10)),
        LeaveBeginDayStatusID: 'ALL',
        LeaveFinishDate:
          this.$dateFormat(this.leaveInfo.leaveFinishDate) ||
          this.$dateFormat(new Date().toISOString().substr(0, 10), {
            addValue: 1,
            addUnit: 'd'
          }),
        LeaveFinishDayStatusID: 'ALL',
        LeaveAmountDay: this.leaveInfo.leaveAmountDay || 0,
        LeaveAmountDayAll: this.leaveInfo.leaveAmountDayAll || 0,
        CheckSaturday: this.leaveInfo.checkSaturday
          ? this.leaveInfo.checkSaturday
          : false,
        CheckSunday: this.leaveInfo.checkSunday
          ? this.leaveInfo.checkSunday
          : false,
        CheckHoliday: this.leaveInfo.checkHoliday
          ? this.leaveInfo.checkHoliday
          : false,
        WifeName: this.leaveInfo.wifeName || '',
        DeliverDate:
          this.$dateFormat(this.leaveInfo.deliverDate) ||
          this.$dateFormat(new Date().toISOString().substr(0, 10)),
        Address: this.leaveInfo.address || '',
        EmployeeApproveID: this.leaveInfo.employeeApproveID || '',
        EmployeeApproveTypeID: 'Approve',
        OverLimitDay: this.leaveInfo.overLimitDay || 0
      }

      this.otherData = {
        leaveOneDay:
          this.leaveInfo.leaveBeginDate === this.leaveInfo.leaveFinishDate &&
          this.leaveInfo.leaveBeginDayStatusID ===
            this.leaveInfo.leaveFinishDayStatusID,
        docName: this.leaveInfo.docFileName || null,
        docFileName: null,
        leaveDayName: this.leaveInfo.leaveDayName || 'วัน',
        budgetYear:
          this.leaveInfo.budgetYear || new Date().toISOString().substr(0, 4),
        employeeApproveKeyword: '',
        employeeApprove: {
          ID: this.leaveInfo.employeeApproveNameID,
          Tha: this.leaveInfo.employeeApproveNameTha,
          Eng: this.leaveInfo.employeeApproveNameEng
        },
        employeeName: {
          Tha: this.leaveInfo.employeeNameTha,
          Eng: this.leaveInfo.employeeNameEng
        },
        positionName: {
          Tha: this.leaveInfo.positionNameTha,
          Eng: this.leaveInfo.positionNameEng
        },
        orgNameAll: {
          Tha: this.leaveInfo.orgNameAllTha,
          Eng: this.leaveInfo.orgNameAllEng
        },
        warningMessage: '',
        leaveAssignDateText: this.$dateFormatByLang(
          this.leaveInfo.leaveAssignDate
        )
      }

      this.onChangeDaySelection()
    },

    async onSearchEmpApprove(keyword) {
      this.otherData.employeeApproveKeyword = keyword
      if (this.otherData.employeeApproveKeyword.length > 1) {
        this.employeeApproveList = await this.apiPostSearchEmployeeByKeyword()
      }
    },
    openDialog() {
      this.searchDialog = true
      this.employeeApproveList = []
      this.dataSelect = {
        employeeID: '',
        employeeNameTha: '',
        employeeNameEng: '',
        EmployeeApproveID: ''
      }
    },
    onSelectApprover(item) {
      this.dataSelect = {
        employeeID: item.employeeID,
        employeeNameTha: item.employeeNameTha,
        employeeNameEng: item.employeeNameEng,
        EmployeeApproveID: item.employeeID
      }
      // this.otherData.employeeApprove.ID = item.employeeID
      // this.otherData.employeeApprove.Tha = item.employeeNameTha
      // this.otherData.employeeApprove.Eng = item.employeeNameEng
      this.form.EmployeeApproveID = item.employeeID
      this.leaveApproverStatus = false
    },
    btnSubmitSelect() {
      this.otherData.employeeApprove.ID = this.dataSelect.employeeID
      this.otherData.employeeApprove.Tha = this.dataSelect.employeeNameTha
      this.otherData.employeeApprove.Eng = this.dataSelect.employeeNameEng
      this.form.EmployeeApproveID = this.dataSelect.EmployeeApproveID
      this.searchDialog = false
    },
    // onSelectApprover(item) {
    //   this.otherData.employeeApprove.ID = item.employeeID
    //   this.otherData.employeeApprove.Tha = item.employeeNameTha
    //   this.otherData.employeeApprove.Eng = item.employeeNameEng
    //   this.form.EmployeeApproveID = item.employeeID
    // },

    async onChangeDaySelection() {
      const res = await this.apiPostComputeDay()
      const firstItem = res.length > 0 ? res[0] : null

      if (firstItem) {
        this.form.LeaveAmountDay = firstItem.leaveAmountDay || 0
        this.form.LeaveAmountDayAll = firstItem.leaveAmountDayAll || 0
        this.form.OverLimitDay = firstItem.overLimitDay || 0

        this.otherData.budgetYear = firstItem.budgetYear
        this.otherData.leaveTypeName = firstItem.leaveTypeName
        this.otherData.leaveTypeDesc = firstItem.comment
        this.otherData.leaveDayName = firstItem.leaveDayName
        this.otherData.limitDay = firstItem.limitDay || 0
        this.otherData.warningMessage = firstItem.warningMessage
      }

      if (res.length > 1) {
        const secondItem = res[1]
        this.nextBudgetYearData.has = true
        this.nextBudgetYearData.budgetYear = secondItem.budgetYear
        this.nextBudgetYearData.leaveDayName = secondItem.leaveDayName
        this.nextBudgetYearData.statLeaveLastDay =
          secondItem.statLeaveLastDay || 0
        this.nextBudgetYearData.statLeaveNowDay =
          secondItem.statLeaveNowDay || 0
        this.nextBudgetYearData.statLeaveTotal = this.nextBudgetYearData.statLeaveTotal =
          parseFloat(this.nextBudgetYearData.statLeaveLastDay) +
          parseFloat(this.nextBudgetYearData.statLeaveNowDay)
        this.nextBudgetYearData.relaxLastYearDay =
          secondItem.relaxLastYearDay || 0
        this.nextBudgetYearData.limitDay = secondItem.limitDay || 0
        this.nextBudgetYearData.warningMessage = secondItem.warningMessage
      } else {
        this.nextBudgetYearData.has = false
      }
    },

    onCloseUsedLeaveLimitDialog() {
      this.usedLeaveLimitDialog = false
      this.usedLeaveLimitMessage = ''
      this.$router.replace(
        `/leave/list/${this.$route.params.guid || this.$guid}`
      )
    },

    async onSubmitForm() {
      if (this.$refs.form.validate() && this.form.EmployeeApproveID) {
        this.conDialogOnSubmitForm = true
      } else {
        let element = ''
        if (!this.form.LeaveHead) {
          element = 'LeaveHead'
        } else if (!this.form.LeaveReason) {
          element = 'LeaveReason'
        } else {
          element = 'LeaveApprover'
        }
        this.leaveApproverStatus = true
        this.$vuetify.goTo(this.$refs[element], { offset: 20 })
      }
    },
    async conOnSubmitForm() {
      this.conDialogOnSubmitForm = false
      this.loading1 = true
      try {
        const res = await this.apiPostCreateCommonLeave()
        if (res) {
          this.$router.push('/leave/pending/' + this.$guid)
        }
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiGetLeaveInfo() {
      this.loading = true
      let body = {
        employeeId: this.$guid,
        leaveOrderId: this.leaveOrderId,
        leaveType: this.type
      }
      const action = 'leave/getHelpWifeInfo'

      try {
        const res = await this.$store.dispatch(action, body)
        return res.data?.data[0] || {}
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiPostSearchEmployeeByKeyword() {
      this.loading = true
      const body = {
        Keyword: this.otherData.employeeApproveKeyword
      }
      try {
        const res = await this.$store.dispatch(
          'leave/postSearchEmployeeByKeyword',
          body
        )
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiPostComputeDay() {
      this.loading = true
      // const finishDate =
      //   this.otherData.leaveOneDay || this.form.LeaveBeginDayStatusID === 'AM'
      //     ? this.form.LeaveBeginDate
      //     : this.form.LeaveFinishDate

      const finishDate =
        this.otherData.leaveOneDay || this.form.LeaveBeginDayStatusID === 'AM'
          ? this.form.LeaveBeginDate
          : this.form.LeaveBeginDate >= this.form.LeaveFinishDate
          ? this.$dateFormat(this.form.LeaveBeginDate, {
              addUnit: 'd',
              addValue: 1
            })
          : this.form.LeaveFinishDate

      const body = {
        EmployeeID: this.$guid,
        LeaveTypeID: this.type,
        LeaveBeginDate: this.form.LeaveBeginDate,
        LeaveBeginDayStatusID: this.form.LeaveBeginDayStatusID,
        LeaveFinishDate: finishDate,
        LeaveFinishDayStatusID: this.form.LeaveFinishDayStatusID,
        CheckSaturday: this.form.CheckSaturday,
        CheckSunday: this.form.CheckSunday,
        CheckHoliday: this.form.CheckHoliday
      }
      try {
        const res = await this.$store.dispatch('leave/postComputeDay', body)
        const data = res.data?.data || []
        const usedLeaveLimit = data.find(
          item =>
            item.usedLeaveLimitMessage !== null &&
            item.usedLeaveLimitMessage !== ''
        )

        if (usedLeaveLimit) {
          this.usedLeaveLimitMessage = usedLeaveLimit.usedLeaveLimitMessage
          this.usedLeaveLimitDialog = true
          return []
        }

        return data
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiPostCreateCommonLeave() {
      this.loading = true
      try {
        let formData = new FormData()
        let formStringConverted = {}
        for (const [key, value] of Object.entries(this.form)) {
          // console.log(key, value, typeof value)
          if (typeof value === 'boolean') {
            formStringConverted[key] = value ? 'true' : 'false'
          } else if (typeof value === 'number') {
            formStringConverted[key] = value.toString()
          } else {
            formStringConverted[key] = value ? value.toString() : ''
          }
        }
        // console.log(formStringConverted)

        if (this.otherData.docFileName) {
          formData.append('filename1', this.otherData.docFileName)
        }

        formStringConverted.LeaveFinishDate = this.otherData.leaveOneDay
          ? formStringConverted.LeaveBeginDate
          : formStringConverted.LeaveFinishDate

        formData.append('dataEform', JSON.stringify(formStringConverted))

        // for (let pair of formData.entries()) {
        //   console.log(pair[0] + ', ' + pair[1])
        // }

        const res = await this.$store.dispatch(
          'leave/postCreateHelpWifeLeave',
          formData
        )
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
